import React from 'react'
import Galeria from '../components/Galeria';
import Carousel from '../components/Carousel'
import ExperienciaCounter from '../components/ExperienciaCounter';

import {Paper } from '@mui/material';

const Home = () => {
  return (
  <>
    <Galeria/>
    <Carousel />
    <ExperienciaCounter />
  </>
  )
}


export default Home;
